import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLayerOrder = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_17239_30457)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M8.05113 11.7462L14.2263 6.93865L15.6023 5.8731L8.05113 0L0.5 5.8731L1.86759 6.93865L8.05113 11.7462ZM8.05113 13.8773L1.8592 9.06974L0.5 10.1269L8.05113 16L15.6023 10.1269L14.2347 9.06135L8.05113 13.8773Z",
				fill: "currentColor"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_17239_30457",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 16,
				height: 16,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgLayerOrder);
export default ForwardRef;
